jQuery(document).ready(function($) {

    /* Fancy Box
    ------------------------------*/
    $('.gallery').each(function() {
        $(this).find('.gallery-item').each(function() {
          $(this).find(".gallery-icon a").attr('data-fancybox', 'images');
          var caption = $(this).find(".gallery-caption").html();
          $(this).find(".gallery-icon a").attr('data-caption', caption);
        });
    });
     $('.owl-carousel').owlCarousel({
        items:1,
        dots: true,
        loop:true,
        autoHeight: true,
        autoplay:true,
        autoplayTimeout:4500
    });

    $().fancybox({
      selector : '[data-fancybox="images"]',
      loop     : true
    });

      new WOW().init();

    /* Smooth Scrolling
    ------------------------------*/
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });
      /* Back to Top
      ------------------------------*/
      $(window).scroll(function() {
          if ($(this).scrollTop() >= 50) {    // If page is scrolled more than 50px
              $('#backToTop').fadeIn();    // Fade in the arrow
          } else {
              $('#backToTop').fadeOut();   // Else fade out the arrow
          }
      });
      $('#backToTop').click(function() {      // When arrow is clicked
          $('body,html').animate({
              scrollTop : 0                  // Scroll to top of body
          }, 500);
      });
});